import React, { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Chip from "../../../../components/basics/Chip";
import TableDefault from "../../../../components/grid/TableDefault";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
} from "../styles/Prescricao";

const columnsHistory = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
    style: { width: 100 },
  },
  {
    id: "id",
    label: "Id",
    align: "center",
    style: { width: 100 },
  },
  {
    id: "data",
    label: "Data",
    flex: 1,
  },
  {
    id: "total",
    label: "Valor",
    align: "center",
    flex: 1,
  },
  {
    id: "pedidos",
    label: "Pedidos",
    align: "center",
    flex: 1,
  },
];

const AccordionPrescricaoHistorico = ({ ...props }) => {
  const { handleChangeOpenAcordion } = usePrescricaoController();
  const { expanded, history, setModalPrescriptionOpen, loading } =
    useContext(PrescricaoContext);

  return (
    <>
      <Grid item xs={12}>
        <Accordion expanded={expanded.history || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("history")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("history")}
                >
                  <Chip label="HISTÓRICO" bgcolor={"default"} />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar prescrição">
                    <IconButtonStyled
                      onClick={() => setModalPrescriptionOpen(true)}
                    >
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        loading={loading.tables ? true : false}
                        columns={columnsHistory}
                        values={history}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default AccordionPrescricaoHistorico;
